/**
 * Reset Password Page
 * Requirements: 6.7
 */
import React from 'react';
import { Box, Container } from '@mui/material';
import { ResetPasswordForm } from '../components';

export const ResetPasswordPage: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <ResetPasswordForm />
      </Box>
    </Container>
  );
};
